<template>
    <div class="bordas acoes-content">
        <download-excel
            class="btn btn-success btn-sm btn-acoes pointer"
            :fetch="extrair"
            :fields="excelColunas"
            worksheet="TrocaPlantao"
            name="RelatorioTrocaPlantao.xls"
        >
            Extração Troca de Plantão
        </download-excel>
    </div>
</template>

<script>
export default {
    data() {
        return {
            excelColunas: {
                'Cód. Enfermaria': 'codigoEnfermaria',
                'Cód. Leito': 'codigoLeito',
                'Número Prontuário': 'numeroProntuario',
                'Data / Hora da Admissão': 'dataHoraAdmissao',
                'Nome Paciente': 'nomePaciente',
                'Nome Social Paciente': 'nomeSocialPaciente',
                'Idade Paciente': 'idadePaciente',
                'Hipótese Diagnóstica': 'hipoteseDiagnostico',
                'Oxigenação': 'oxigenacao',
                'Situacao': 'situacao',
            }
        }
    },
    computed: {
        listagemFiltradaStatus () {
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        }
    },
    methods: {
        filtroAcompanhamento () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 20 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 20)
        },
        async extrair() {
            try {
                let resp = await this.$store.dispatch('leitos/extracaoInternados', this.unidadeSelecionada.cnes)
                if (resp.data.status === true) return resp.data.dados
                this.$store.commit("sessao/setError", {status: false, msg: 'Nenhuma informação encontrada'})
            }
            catch (e) {
                console.error(e)
            }
        }
    }
}
</script>

<style>
.covid-icone-botao {
    margin-right: 6px;
    display: inline-block;
    color: #fff;
    text-align: center;
    font-weight: 700;
    background-color: #451690;
    width: 14px;
    font-size: .8rem;
    border-radius: 8px;
}

.btn-outline-purple {
    color: #250d54;
    border-color: #250d54;
}

.btn-outline-purple:hover,
.btn-purple {
    color: #fff;
    background-color: #250d54;
    border-color: #250d54;
}
</style>

